import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { listAccounts, type AccountRow } from "../api/admin";

export function AccountsPage() {
  const { api } = useAuth();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState<AccountRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    listAccounts(api, q)
      .then((r) => { if (!cancelled) setRows(r.accounts); })
      .catch((e) => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [api, q]);

  return (
    <div className="vstack">
      <div>
        <h1>Accounts</h1>
        <p className="meta">Search by email, display name, or account ULID.</p>
      </div>
      <div className="field">
        <input
          type="text"
          placeholder="Search…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      {error && <div className="error">{error}</div>}
      <div className="card">
        {loading && <p className="meta">Loading…</p>}
        {!loading && rows.length === 0 && <p className="meta">No accounts matched.</p>}
        {rows.map((r) => (
          <div className="row" key={r.id}>
            <div>
              <div className="row-title">
                <Link to={`/accounts/${r.id}`}>{r.email}</Link>
                {r.deleted_at && <span className="subtle"> · deleted</span>}
              </div>
              <div className="row-meta">
                {r.display_name} · {r.role} · {r.acct_kind}
                {r.totp_enabled_at ? " · 2FA" : ""}
                {r.locked_until ? ` · locked until ${r.locked_until}` : ""}
                {r.failed_login_count > 0 ? ` · ${r.failed_login_count} fails` : ""}
              </div>
            </div>
            <div className="row-meta">{r.created_at.slice(0, 10)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
